import ReviewReply, { ReviewReplyInitializer } from './ReviewReply';

export interface ReviewInitializer {
  id: number;
  name: string;
  gender: string;
  birthday: string;
  rating: number;
  comment: string;
  reply?: ReviewReplyInitializer;
  createdAt: string;
  updatedAt: string;
}

export default class Review {
  public readonly id: number;
  public readonly name?: string;
  public readonly gender?: string;
  public readonly birthday?: string;
  public readonly rating: number;
  public readonly comment: string;
  public readonly reply?: ReviewReply;
  public readonly createdAt: string;
  public readonly updatedAt: string;

  constructor(init: ReviewInitializer) {
    this.id = init.id;
    this.name = init.name;
    this.gender = init.gender;
    this.birthday = init.birthday;
    this.rating = init.rating;
    this.comment = init.comment;
    this.reply = init.reply;
    this.createdAt = init.createdAt;
    this.updatedAt = init.updatedAt;
  }
}
